import AMBEV_DOMAINS from '../../../../common/constants/ambev-domains';
import { IUsersResponse } from '../../interfaces/IUsersResponse';

export default function isAmbevUser(user: IUsersResponse): boolean {
    return AMBEV_DOMAINS.some(domain => user.email.includes(domain));
}
